// test2998
(2998 && 0);
